<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <ng-container *ngIf="!data.oneTimeApiKey">
    <h1 mat-dialog-title>Are you sure?</h1>
    <div mat-dialog-content>
      <p>This could cause your client to stop working!</p>
      <p *ngIf="data.newKeyRequest">Old keys will only remain valid for 6 hours!</p>
    </div>
    <div mat-dialog-actions fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
      <button *ngIf="!data.newKeyRequest" mat-flat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
        <mat-icon>done</mat-icon> Confirm
      </button>
      <button *ngIf="data.newKeyRequest" mat-flat-button color="accent" [mat-dialog-close]="true" cdkFocusInitial>
        <mat-icon>done</mat-icon> Create New Key
      </button>
      <button mat-stroked-button color="basic" (click)="cancelClick()">
        <mat-icon>clear</mat-icon> Cancel
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="data.oneTimeApiKey">
    <h1 mat-dialog-title>{{ data.clientName }} ApiKey</h1>
    <div mat-dialog-content>
      <strong class="highlight">{{ data.oneTimeApiKey }}</strong>
      <div *ngIf="copied"><span class="highlight">Copied!</span></div>
      <div *ngIf="!copied">
        <mat-icon (click)="copyKeyToClipboard()">
          content_copy
        </mat-icon></div>
      <p>Please copy this ApiKey before dismissing this message!</p>
    </div>
    <div mat-dialog-actions fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
      <button [disable]="!copied" mat-flat-button color="warn" (click)="confirmCopyClick()">
        <mat-icon>content_copy</mat-icon> Confirm Copied
      </button>
    </div>
  </ng-container>
</div>